import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { MaterialDlaKlienta } from '../../../shared/models/material-dla-klienta.model';

@Component({
  selector: 'ngx-materialy',
  templateUrl: './materialy.component.html',
  styleUrls: ['./materialy.component.scss'],
})
export class MaterialyComponent {

  @ViewChild('hdrTpl', { static: true }) hdrTpl: TemplateRef<any>;

  @Input()
  dane: MaterialDlaKlienta[];

}
